import { Box, Button, Container, Typography } from "@mui/material";

import {
    ArrowForward,
    CheckCircleOutlineOutlined,
    Phone,
} from "@mui/icons-material";

import { StarBorderRounded } from "@mui/icons-material";
import aboutBg from "../../assets/images/about_bg.png";
import aboutBgM from "../../assets/images/about_bg_m.png";
import aboutImage from "../../assets/images/about_s.png";

const features = [
  "Premium Cleaning Services",
  "Shoe Cleaning & Repair",
  "Wedding Dress Care",
  "Custom Printing Services",
  "Express Alterations",
  "Pickup & Delivery Available",
];

function AboutPreview() {
  return (
    <Box
      sx={{
        py: {
          xs: 6,
          md: 10,
        },

        backgroundImage: { xs: `url(${aboutBgM})`, md: `url(${aboutBg})` },
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",

        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexDirection: {
              xs: "column",
              lg: "row",
            },

            alignItems: "center",

            gap: {
              xs: 5,
              md: 8,
            },
          }}
        >
          {/* IMAGE */}

          <Box
            sx={{
              flex: 1,

              width: "100%",

              position: "relative",

              display: "flex",

              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              src={aboutImage}
              alt="Comet Cleaners"
              sx={{
                width: "100%",

                maxWidth: {
                  xs: "100%",
                  md: 550,
                },
                height: {
                  xs: "100%",
                  md: "100%",
                },

                objectFit: "cover",

                borderRadius: "32px",

                // boxShadow: "0 30px 80px rgba(0,87,255,.12)",
              }}
            />

            {/* EXPERIENCE */}

            <Box
              sx={{
                position: "absolute",

                bottom: {
                  xs: 15,
                  md: 45,
                },

                right: {
                  xs: 15,
                  md: 95,
                },

                background: "rgba(255,255,255,.95)",

                backdropFilter: "blur(15px)",

                borderRadius: "20px",

                px: 2.5,

                py: 1.5,

                boxShadow: "0 20px 50px rgba(0,0,0,.08)",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "24px",
                    md: "32px",
                  },

                  fontWeight: 800,

                  color: "#0057ff",

                  lineHeight: 1,
                }}
              >
                10+
              </Typography>

              <Typography
                sx={{
                  fontSize: "13px",

                  fontWeight: 600,

                  color: "#0f172a",
                }}
              >
                Years Experience
              </Typography>
            </Box>

            {/* CUSTOMER */}

            <Box
              sx={{
                position: "absolute",

                top: {
                  xs: 10,
                  md: 55,
                },

                left: {
                  xs: 10,
                  md: 55,
                },

                background: "rgba(255,255,255,.95)",

                backdropFilter: "blur(15px)",

                borderRadius: "20px",

                px: 2.5,

                py: 1.5,

                boxShadow: "0 20px 50px rgba(0,0,0,.08)",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "24px",
                    md: "32px",
                  },

                  fontWeight: 800,

                  color: "#0057ff",

                  lineHeight: 1,
                }}
              >
                1000+
              </Typography>

              <Typography
                sx={{
                  fontSize: "13px",

                  fontWeight: 600,

                  color: "#0f172a",
                }}
              >
                Happy Customers
              </Typography>
            </Box>
          </Box>

          {/* CONTENT */}

          <Box
            sx={{
              flex: 1,

              width: "100%",
            }}
          >
            {/* BADGE */}

            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,

                px: {
                  xs: 1.8,
                  md: 2.2,
                },

                py: {
                  xs: 0.7,
                  md: 0.9,
                },

                borderRadius: "999px",

                background: "rgba(255,255,255,0.75)",

                backdropFilter: "blur(14px)",

                border: "1px solid rgba(0,87,255,0.12)",

                boxShadow: "0 8px 25px rgba(0,87,255,0.06)",

                mb: {
                  xs: 2,
                  md: 2.5,
                },
              }}
            >
              <StarBorderRounded
                sx={{
                  color: "#0057ff",

                  fontSize: {
                    xs: 14,
                    md: 16,
                  },
                }}
              />

              <Typography
                sx={{
                  color: "#0057ff",

                  fontWeight: 700,

                  textTransform: "uppercase",

                  letterSpacing: "1px",

                  lineHeight: 1,

                  fontSize: {
                    xs: "10px",
                    sm: "11px",
                    md: "12px",
                  },
                }}
              >
                About Comet Cleaners
              </Typography>
            </Box>

            {/* HEADING */}

            <Typography
              sx={{
                fontSize: {
                  xs: "32px",
                  sm: "40px",
                  md: "54px",
                },

                fontWeight: 800,

                lineHeight: 1.08,

                color: "#0f172a",

                maxWidth: "650px",
              }}
            >
              Premium Care
              <Box
                component="span"
                sx={{
                  color: "#0057ff",
                }}
              >
                {" "}
                With Attention
              </Box>{" "}
              To Every Detail
            </Typography>

            {/* DESCRIPTION */}

            <Typography
              sx={{
                mt: 3,

                color: "#64748b",

                fontSize: {
                  xs: "15px",
                  md: "18px",
                },

                lineHeight: 1.9,

                maxWidth: "650px",
              }}
            >
              At Comet Cleaners, we provide professional cleaning, alterations,
              shoe repair, custom printing, wedding dress care, handbag
              cleaning, rug cleaning and home essentials care trusted by
              families across Ajax.
              <br />
              Every item receives expert attention to ensure exceptional
              quality, lasting freshness and professional results.
            </Typography>

            {/* FEATURES */}

            <Box
              sx={{
                display: "flex",

                flexWrap: "wrap",

                gap: 2,

                mt: 4,
              }}
            >
              {features.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "calc(50% - 8px)",
                    },

                    display: "flex",

                    alignItems: "center",

                    gap: 1,
                  }}
                >
                  <CheckCircleOutlineOutlined
                    sx={{
                      color: "#0057ff",
                      fontSize: 22,
                    }}
                  />

                  <Typography
                    sx={{
                      fontWeight: 500,

                      color: "#0f172a",

                      fontSize: {
                        xs: "14px",
                        md: "15px",
                      },
                    }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* BUTTONS */}

            <Box
              sx={{
                display: "flex",

                flexWrap: "wrap",

                gap: 2,

                mt: 5,
              }}
            >
              <Button
                variant="contained"
                endIcon={<ArrowForward />}
                sx={{
                  height: 54,

                  px: 4,

                  borderRadius: "50px",

                  textTransform: "none",

                  fontWeight: 700,
                }}
              >
                Learn More
              </Button>

              <Button
                variant="outlined"
                startIcon={<Phone />}
                sx={{
                  height: 54,

                  px: 4,

                  borderRadius: "50px",

                  textTransform: "none",

                  fontWeight: 700,
                }}
              >
                Call Now
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default AboutPreview;
